export * from './fixtureSummaryBlockLeagueTable.types';
export { default as FixtureSummaryBlockLeagueTable } from './fixtureSummaryBlockLeagueTable.component';
